import { render, staticRenderFns } from "./MyRaces.vue?vue&type=template&id=65285556&"
import script from "./MyRaces.vue?vue&type=script&lang=js&"
export * from "./MyRaces.vue?vue&type=script&lang=js&"
import style0 from "./MyRaces.vue?vue&type=style&index=0&id=65285556&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports